const CONFIG = {
  DriversProgression3Level: {
    showLegends: true,
    filterType: 'periods',
  },
  SearchDriversProgression3Level: {
    type: 'SearchKeywords',
    showLegends: false,
    filterType: 'periods',
  },
  DriversProgressionWithoutSentiments3Level: {
    type: 'SearchKeywords',
    showLegends: false,
    filterType: 'periods',
  },
  DriversProgression3Level_v1: {
    showLegends: true,
    filterType: 'periods',
  },
  SearchDriversProgression3Level_v1: {
    type: 'SearchKeywords',
    showLegends: false,
    filterType: 'periods',
  },
  DriversProgressionWithoutSentiments3Level_v1: {
    type: 'SearchKeywords',
    showLegends: false,
    filterType: 'periods',
  },
  SegmentDriversOnlyAnalysis3Level: {
    showLegends: true,
    filterType: 'segments',
  },
  SegmentDriversOnlyAnalysisWithoutSentiments3Level: {
    type: 'SearchKeywords',
    showLegends: false,
    filterType: 'segments',
  },
}

export default CONFIG